module.exports = __webpack_public_path__ + "img/1inch_logo.84249222.svg";